import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { TranslateService } from "@ngx-translate/core";
import { LogoutService } from 'app/helpers/logout.service';
import { UserDataService } from 'app/helpers/user-data.service';
import { AlertsService } from "./alerts.service";

@Component({
  selector: 'app-alerts-welcome',
  templateUrl: './alerts-welcome.component.html',
  styleUrls: ['./alerts-welcome.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AlertsWelcomeComponent implements OnInit, AfterViewInit {
  @ViewChild('stepper') private matStepper: MatStepper;

  alertData = this.alertsService.alertData;
  currentStep: number = 0;

  constructor(
    private router: Router,
    private _fuseConfigService: FuseConfigService,
    private alertsService: AlertsService,
    private userDataService: UserDataService,
    private translate: TranslateService,
    private logoutService: LogoutService
  ) {
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: false,
        },
        footer: {
          hidden: false,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    if (this.alertData == null || this.alertData == undefined || this.alertData.length == 0) {
      localStorage.clear();
      this.router.navigateByUrl("/auth/login");
    }
  }

  onStepChange(event) {
    this.currentStep = event.selectedIndex;
  }

  redirectToMemberView() {
    var userId = this.userDataService.userData.id;
    this.router.navigate(["" + userId]);
  }

  goBack() {
    this.matStepper.previous();
  }

  goForward() {
    this.matStepper.next();
  }
}